import { BASE_URL } from '@config'

/** 基础查询接口
 * ————————————————————————————————————————————————————————————————————————————————————————————*/

 /**
 * 系统初始化
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const SYSTEM_INITIALIZATION = {
    url: `${BASE_URL}/gongbaojin-operating-admin/initialization/official-website`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}

/**
 * 附件上传
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const UPLOAD_FILE = {
    url: `${BASE_URL}/gongbaojin-public-resource/organization/uploadAttachments`,
    method: 'put',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}
/**
 * 用户附件上传
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const UPLOAD_USER_FILE = {
    url: `${BASE_URL}/gongbaojin-file/file/userUploadAttachments`,
    method: 'put',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}
/**
 * 系统附件上传
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const UPLOAD_SYSTEM_FILE = {
    url: `${BASE_URL}/gongbaojin-file/file/sysUploadAttachments`,
    method: 'put',
    headers: {
        'Content-Type': 'application/json'
    },
    timeout: 30000
}

/**
 * 发送短信验证码
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const SEND_SMS_CODE = {
    url: `${BASE_URL}/gongbaojin-public-resource/business/sendSmsCode`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}
/**
 * 根据字典表code获取枚举
 * @type {{headers: {"Content-Type": string}, method: string, url: string, timeout: number}}
 */
export const GET_SYSTEM_ENUM = {
    url: `${BASE_URL}/gongbaojin-operating-admin/dict/list-code`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}

/**
 * 地区接口
 */
export const GET_SYSTEM_AREA = {
    url: `${BASE_URL}/gongbaojin-user/sys-area//list`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}
/**
 * 根据areaCode查询省市区
 * 未传code 默认 返回系统 负责地区列表
 */
export const GET_AREA_BY_AREA_CODE = {
    url: `${BASE_URL}/gongbaojin-operating-admin/sys-area/findAreaByAreaCode`,
    method: 'get',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    timeout: 30000
}
